import React from 'react'
import HeaderBlock from '../../../core/components/header-block/HeaderBlock'
import { TertiaryButtonLight } from '../../../core/components/unilink/index'
import LoadingSwitch from '../../../core/components/loading-switch/LoadingSwitch'
import HeaderNav from '../../../core/components/header-nav/HeaderNav'
import {ProfileDefaultUserPicture} from '../../../core/components/default-user-picture/DefaultUserPicture'
import './profileHeader.css'

const ProfileHeader = ({
  isFetching,
  displayName,
  pictureUrl,
  numSolved,
  numRevisions,
  isPersonalProfile,
  match,
  location
}) => {
  const tabs = {}
  tabs[`${match.url}`] = 'Contributions'
  tabs[`${match.url}/problems`] = 'Problems'
  const activeTab = tabs[location.pathname]
  const activeState = (
    <div className="profile-header__content">
      <div className="profile-header__user">
        <ProfileDefaultUserPicture className="profile-header__picture" />
        <div className="profile-header__info">
          <h1 className="profile-header__name"> {displayName} </h1>
          <div className="profile-header__stats">
            {
              isPersonalProfile
                ? <div className="profile-header__problems-solved">
                  <b>{numSolved}</b> problems solved{' '}
                </div>
                : null
            }
            <div className="profile-header__revisions-authored">
              <b>{numRevisions}</b> revisions authored{' '}
            </div>
          </div>
        </div>
      </div>
      <div className="profile-header__edit-profile">
        {isPersonalProfile ? (
          <TertiaryButtonLight to={`${match.url}/edit`}> Edit Profile </TertiaryButtonLight>
        ) : null}
      </div>
    </div>
  )
  const loadingState = (
    <div className="profile-header__content">
      <div className="profile-header__user">
        <div className="profile-header__picture profile-header__picture--loading" />
        <div className="profile-header__info ">
          <div className="profile-header__name profile-header__name--loading" />
          <div className="profile-header__stats profile-header__stats--loading" />
        </div>
      </div>
      <div className="profile-header__edit-profile" />
    </div>
  )
  return (
    <HeaderBlock className="profile-header">
      <div className="profile-header__container">
        <LoadingSwitch
          activeState={activeState}
          loadingState={loadingState}
          isLoading={isFetching}
        />
        <HeaderNav
          tabs={tabs}
          activeTab={activeTab}
          className="profile-header__nav"
        />
      </div>
    </HeaderBlock>
  )
}

export default ProfileHeader



// WEBPACK FOOTER //
// ./src/domains/user/components/ProfileHeader.js